(function () {
  'use strict';
  function getGrid(scope) { return scope.querySelector('[class~="#grid"][style*="--columns"]'); }
  function pageOf(url) { var m = (url || '').match(/[?&]page=(\d+)/); return m ? parseInt(m[1], 10) : 1; }
  function nextUrlFrom(doc, wantPage) {
    var items = doc.querySelectorAll('collection-nav-item');
    for (var i = 0; i < items.length; i++) {
      var to = items[i].getAttribute('to') || '';
      if (pageOf(to) === wantPage) return to;
    }
    return null;
  }
  function kf() {
    if (document.getElementById('inf-scroll-kf')) return;
    var s = document.createElement('style');
    s.id = 'inf-scroll-kf';
    s.textContent = '@keyframes infspin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
  function setup(provider) {
    var grid = getGrid(provider);
    if (!grid || grid.__infWired) return;
    var nextUrl = nextUrlFrom(document, pageOf(location.search) + 1);
    if (!nextUrl) return;
    grid.__infWired = true;
    kf();
    provider.querySelectorAll('[class~="#pagination"],[class~="#pagination-mobile"]').forEach(function (n) {
      var w = n.closest('.mobile-hidden,.desktop-hidden') || n;
      w.style.display = 'none';
    });
    var host = grid.parentElement;
    var spinner = document.createElement('div');
    spinner.style.cssText = 'display:none;justify-content:center;align-items:center;padding:2rem 0;color:#333;';
    spinner.innerHTML = '<span style="width:28px;height:28px;border:3px solid rgba(0,0,0,.15);border-top-color:currentColor;border-radius:50%;display:inline-block;animation:infspin .7s linear infinite"></span>';
    host.appendChild(spinner);
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'width:100%;height:1px;';
    host.appendChild(sentinel);
    var loading = false, done = false;
    function cont() {
      if (done) return;
      requestAnimationFrame(function () {
        var r = sentinel.getBoundingClientRect();
        if (r.top <= window.innerHeight + 600) load();
      });
    }
    function load() {
      if (loading || done || !nextUrl) return;
      loading = true;
      spinner.style.display = 'flex';
      var loaded = pageOf(nextUrl);
      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = getGrid(doc);
          if (ng && ng.children.length) {
            var frag = document.createDocumentFragment();
            var kids = Array.prototype.slice.call(ng.children);
            for (var i = 0; i < kids.length; i++) frag.appendChild(document.importNode(kids[i], true));
            grid.appendChild(frag);
          }
          nextUrl = nextUrlFrom(doc, loaded + 1);
          if (!nextUrl) done = true;
        })
        .catch(function () { done = true; })
        .then(function () {
          loading = false;
          spinner.style.display = 'none';
          if (done && sentinel.parentNode) sentinel.remove();
          else cont();
        });
    }
    new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { load(); break; }
    }, { rootMargin: '600px 0px' }).observe(sentinel);
  }
  function boot() { document.querySelectorAll('collection-provider').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () {
      t = null;
      document.querySelectorAll('collection-provider').forEach(function (p) {
        var g = getGrid(p);
        if (g && !g.__infWired) setup(p);
      });
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
